<nav class="navbar navbar-expand-xl navbar-light bg-light fixed-top">
  <div class="container-fluid">
    <a href="#">
      <div
        id="logoImage"
        alt="California Hispanic Chambers of Commerce Logo"
        data-bs-target="#sidebar_left"
        data-bs-toggle="offcanvas"
        class="img-fluid hlogo rounded"
        role="link"
        aria-label="CAHCC Logo"
      ></div>
    </a>
    <button
      aria-label="menu"
      class="navbar-toggler"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasNavbar"
      aria-controls="offcanvasNavbar"
      >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div
      class="offcanvas offcanvas-end"
      tabindex="-1"
      id="offcanvasNavbar"
      aria-labelledby="offcanvasNavbarLabel"
      data-bs-scroll="true"
      href="#sidebar_left"
      >
      <div class="offcanvas-header">
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>

      <div class="offcanvas-body">
        @if (!menuItems) {
          <ul id="navBarLink" class="navbar-nav justify-content-end flex-grow-1">
            <li>
              <a href="/" class="nav-link" id="home" role="button"> Home </a>
            </li>
            <!-- Advocacy Dropdown Menu-->
            <li class="nav-item dropdown">
              <a
                class="nav-link"
                id="AdvocacyDropdown"
                role="button"
                data-bs-toggle="dropdown disabled"
                aria-expanded="false"
                >
                Advocacy
              </a>
              <ul
                class="dropdown-menu"
                id="AdvocacyDropdown"
                aria-labelledby="AdvocacyDropdown"
                >
                <li>
                  <a [routerLink]="['/policy-perspective']" class="dropdown-item">
                    2023 Policy Perspectives
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/bill-positions']" class="dropdown-item">
                    Bill Positions & Legislative Updates
                  </a>
                </li>
                <li>
                  <a
                    [routerLink]="['/policy-engagement-resources']"
                    class="dropdown-item"
                    >
                    Policy Engagement and Resources
                  </a>
                </li>
                <li>
                  <a
                    [routerLink]="['/policy-coalition']"
                    class="dropdown-item"
                    href="#"
                    >
                    Policy Coalitions
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/chcc-pac']" class="dropdown-item">
                    CHCC PAC
                  </a>
                </li>
              </ul>
            </li>
            <!-- Business Resources Dropdown Menu-->
            <li class="nav-item dropdown">
              <a
                class="nav-link"
                role="button"
                data-bs-toggle="dropdown disabled"
                aria-expanded="false"
                >
                Business Resources
              </a>
              <ul
                id="BusinessResourcesDropdown"
                class="dropdown-menu"
                aria-labelledby="BusinessResourcesDropdown"
                >
                <li>
                  <a
                    class="dropdown-item"
                    href="https://www.chccmarketplace.com/"
                    target="_blank"
                    >
                    Hispanic Marketplace
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="https://www.cahispanicsbdc.org/"
                    target="_blank"
                    >
                    SBDC Regional Center
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="http://www.apogeehealth.solutions/"
                    target="_blank"
                    >Healthcare Solutions</a
                    >
                  </li>
                  <li>
                    <a
                      [routerLink]="['/supplier-diversity-procurement']"
                      class="dropdown-item"
                      >
                      Supplier Diversity & Procurement
                    </a>
                  </li>
                </ul>
              </li>
              <!-- Events Dropdown Menu-->
              <li class="nav-item dropdown">
                <a
                  class="nav-link"
                  role="button"
                  data-bs-toggle="dropdown disabled"
                  aria-expanded="false"
                  >
                  Events
                </a>
                <ul
                  id="EventsDropdown"
                  class="dropdown-menu"
                  aria-labelledby="EventsDropdown"
                  >
                  <li>
                    <a
                      [routerLink]="['annual-convention']"
                      class="dropdown-item"
                      href="#"
                      >
                      Annual Convention
                    </a>
                  </li>
                  <li>
                    <a
                      [routerLink]="['ca-business-policy-summit']"
                      class="dropdown-item"
                      href="#"
                      >
                      California Business Policy Summit
                    </a>
                  </li>
                  <li>
                    <a
                      [routerLink]="['legislative-economic-outlook']"
                      class="dropdown-item"
                      >
                      Legislative & Economic Outlook
                    </a>
                  </li>
                </ul>
              </li>
              <!-- Membership Dropdown Menu-->
              <li class="nav-item dropdown">
                <a
                  class="nav-link"
                  id="MembershipDropdown"
                  role="button"
                  data-bs-toggle="dropdown disabled"
                  aria-expanded="false"
                  >
                  Membership
                </a>
                <ul
                  id="MembersDropdown"
                  class="dropdown-menu"
                  aria-labelledby="MembershipDropdown"
                  >
                  <li>
                    <a
                      [routerLink]="['/chamber-members']"
                      class="dropdown-item"
                      href="#"
                      >
                      Chamber Members
                    </a>
                  </li>
                  <li>
                    <a
                      [routerLink]="['/corporate-membership']"
                      class="dropdown-item"
                      href="#"
                      >
                      Corporate Membership
                    </a>
                  </li>
                </ul>
              </li>
              <!-- About Dropdown Menu-->
              <li class="nav-item dropdown">
                <a
                  class="nav-link"
                  role="button"
                  data-bs-toggle="dropdown disabled"
                  aria-expanded="false"
                  >
                  About
                </a>
                <ul
                  id="AboutDropdown"
                  class="dropdown-menu AboutDropdown"
                  aria-labelledby="AboutDropdown"
                  >
                  <li>
                    <a [routerLink]="['/about']" class="dropdown-item">
                      About CHCC
                    </a>
                  </li>
                  <li>
                    <a
                      [routerLink]="['/chcc-foundation']"
                      class="dropdown-item"
                      href="#"
                      >
                      CHCC Foundation
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/board-of-directors']" class="dropdown-item">
                      Board of Directors
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/financial']" class="dropdown-item" href="#">
                      Financials
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/staff']" class="dropdown-item" href="#">
                      Staff
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/contact']" class="dropdown-item" href="#">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  routerLink="/login"
                  class="nav-link"
                  id="login"
                  role="button">
                  Sign In
                </a>
              </li>
            </ul>
          } @else {
            <ul id="navBarLink" class="navbar-nav justify-content-end flex-grow-1">
              @for (parent of menuItems; track parent) {
                <span>
                  @if (parent.subMenuItems?.length == 0) {
                    <li>
                      <a [routerLink]="parent.routerLink" class="nav-link" id="home" role="button">{{ parent.name }} </a>
                    </li>
                  } @else {
                    <li class="nav-item dropdown">
                      <a class="nav-link"
                        [id]="parent.name"
                        role="button"
                        data-bs-toggle="dropdown disabled"
                        aria-expanded="false">
                        {{ parent.name }}
                      </a>
                      <ul class="dropdown-menu"
                        [attr.aria-label]="parent.name + ' Dropdown'"
                        [attr.id]="parent.name"
                        style="height: max-content">
                        @for (sub of parent.subMenuItems; track sub) {
                          <span>
                            <li>
                              @if (sub.routerLink) {
                                <a [routerLink]="'/page' + sub.routerLink" class="dropdown-item">
                                  {{ sub.name }}
                                </a>
                              } @else {
                                <a class="dropdown-item"
                                  [href]="sub.hrefLink"
                                  target="_blank">
                                  {{ sub.name }}
                                </a>
                              }
                            </li>
                          </span>
                        }
                      </ul>
                    </li>
                  }
                </span>
              }
              @if (isLoggedIn) {
                <li>
                  <a
                    routerLink="/admin"
                    class="nav-link"
                    role="button">
                    Admin Portal
                  </a>
                </li>
              }
              <li>
                <a
                  (click)="handleSignInOut()"
                  class="nav-link"
                  role="button">
                  {{ isLoggedIn ? 'Sign Out' : 'Sign In' }}
                </a>
              </li>
            </ul>
          }
        </div>
      </div>
    </div>
  </nav>
